import tinymce, { Editor } from 'tinymce';

export default function getAutocompleterContext(editor: Editor, range: Range, trigger: string) {
  const { dom } = editor;
  const root = dom.getParent(range.startContainer, dom.isBlock) || dom.getRoot();
  const seeker = tinymce.dom.TextSeeker(
    dom,
    (node) =>
      dom.isBlock(node) ||
      ['BR', 'IMG', 'HR', 'INPUT'].includes(node.nodeName) ||
      dom.getContentEditable(node) === 'false',
  );
  let start = { container: range.startContainer, offset: range.startOffset };

  // TinyMCE gives us the nearest trigger, which can be the @ inside an email.
  seeker.backwards(
    range.startContainer,
    range.startOffset,
    (node, offset, text) => {
      for (let index = offset - 1; index >= 0; index -= 1) {
        if (text[index] !== '\uFEFF' && /\s/.test(text[index])) {
          start = { container: node, offset: index + 1 };
          return index + 1;
        }
      }
      start = { container: node, offset: 0 };
      return -1;
    },
    root,
  );

  const expanded = range.cloneRange();
  expanded.setStart(start.container, start.offset);
  // TinyMCE inserts invisible FEFF markers when toggling inline formatting.
  const text = expanded
    .toString()
    .replace(/\uFEFF/g, '')
    .replace(/\u00a0/g, ' ');
  return text.startsWith(trigger) ? { range: expanded, pattern: text.trim().slice(trigger.length) } : null;
}
